import React, { Suspense, useEffect, useState } from 'react';

// 레이아웃 지연 로딩 구현
const KorEnvironmentLayout = React.lazy(() => import('./kor-environment/src/Layout'));
const FloneLayout = React.lazy(() => import('./flone/layouts/LayoutOne')); // 경로 수정
const FinappLayout = React.lazy(() => import('./finapp/layouts/LayoutMain')); // Finapp 레이아웃 추가
const GpcLayout = React.lazy(() => import('./gpc/layouts/LayoutMain')); // Gpc 레이아웃 추가
const MidasLayout = React.lazy(() => import('./midas/layouts/LayoutMain')); // Midas 레이아웃 추가

// 🚀 React 컴포넌트 지연 로딩 구현 (finapp용)
const FinappComponent = React.lazy(() => import('../components/finapp')); // finapp React 컴포넌트
const GpcComponent = React.lazy(() => import('../components/gpc')); // gpc React 컴포넌트
const MidasComponent = React.lazy(() => import('../components/midas')); // midas React 컴포넌트

// 로딩 중 표시할 컴포넌트
const LoadingLayout = ({ children }) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div style={{ marginBottom: '20px' }}>레이아웃 로딩 중...</div>
      {children}
    </div>
  );
};

// 레이아웃별 CSS/JS 파일 정의
const LAYOUT_ASSETS = {
  'kor-environment': {
    css: [
      '/assets_kor-environment/css/bootstrap.min.css',
      '/assets_kor-environment/css/fontawesome-all.min.css',
      '/assets_kor-environment/css/animate.min.css',
      '/assets_kor-environment/css/style.css',
      '/assets_kor-environment/css/responsive.css',
      '/assets_kor-environment/css/owl.carousel.min.css',
      '/assets_kor-environment/css/owl.theme.default.min.css',
      '/assets_kor-environment/css/magnific-popup.css',
      '/assets_kor-environment/css/jquery-ui.css',
      'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap'
    ],
    js: [
      '/assets_kor-environment/js/jquery.min.js',
      '/assets_kor-environment/js/bootstrap.bundle.min.js',
      '/assets_kor-environment/js/waypoints.min.js',
      '/assets_kor-environment/js/jquery.counterup.min.js',
      '/assets_kor-environment/js/owl.carousel.min.js',
      '/assets_kor-environment/js/jquery.magnific-popup.min.js',
      '/assets_kor-environment/js/wow.js',
      '/assets_kor-environment/js/appear.js',
      '/assets_kor-environment/js/theme.js'
    ]
  },
  'flone': {
    css: [
      // 'https://fonts.googleapis.com/css?family=Work+Sans:100,200,300,400,500,600,700,800,900',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css',
      '/assets_flone/css/bootstrap.min.css',
      '/assets_flone/css/icons.min.css',
      '/assets_flone/css/plugins.css',
      '/assets_flone/css/style.css',
    ],
    js: [
      '/assets_flone/js/vendor/modernizr-3.6.0.min.js',
      '/assets_flone/js/vendor/jquery-3.6.0.min.js',
      '/assets_flone/js/vendor/bootstrap.bundle.min.js',
      '/assets_flone/js/plugins.js',
      '/assets_flone/js/main.js'
    ]
  },
  'finapp': {
    css: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css',
      '/assets_finapp/css/style.css'
    ],
    js: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js',
      'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js',
      '/assets_finapp/js/plugins/bootstrap.bundle.min.js',
      '/assets_finapp/js/base.js'
    ]
  },
  // 🚀 finapp React 컴포넌트용 에셋 설정
  'finapp-component': {
    css: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css'
    ],
    js: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js',
      'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js'
    ]
  },
  // 🚀 gpc React 컴포넌트용 에셋 설정
  'gpc-component': {
    css: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css'
    ],
    js: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js',
      'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js'
    ]
  },
  // 🚀 midas React 컴포넌트용 에셋 설정
  'midas-component': {
    css: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css'
    ],
    js: [
      'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js',
      'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js',
      'https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js'
    ]
  }
};

// 이미 로드된 애셋 추적
const loadedAssets = {
  css: new Set(),
  js: new Set()
};

// CSS 파일 동적 로드 함수
const loadCssFile = (url) => {
  // 이미 로드된 파일이면 스킵
  if (loadedAssets.css.has(url)) {
    return Promise.resolve(url);
  }
  
  return new Promise((resolve) => {
    try {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      
      // 타임아웃 설정 (10초)
      const timeout = setTimeout(() => {
        console.warn(`CSS 로드 타임아웃: ${url}`);
        resolve(url); // 타임아웃 시에도 계속 진행
      }, 10000);
      
      link.onload = () => {
        clearTimeout(timeout);
        loadedAssets.css.add(url);
        resolve(url);
      };
      
      link.onerror = () => {
        clearTimeout(timeout);
        console.error(`CSS 로드 실패: ${url}`);
        resolve(url); // 에러 시에도 계속 진행
      };
      
      document.head.appendChild(link);
    } catch (error) {
      console.error(`CSS 로드 예외 발생: ${url}`, error);
      resolve(url); // 예외 발생 시에도 계속 진행
    }
  });
};

// JS 파일 동적 로드 함수
const loadJsFile = (url) => {
  // 이미 로드된 파일이면 스킵
  if (loadedAssets.js.has(url)) {
    return Promise.resolve(url);
  }
  
  return new Promise((resolve) => {
    try {
      const script = document.createElement('script');
      script.src = url;
      script.async = false; // 순서대로 실행되도록 async를 false로 설정
      
      // 타임아웃 설정 (10초)
      const timeout = setTimeout(() => {
        console.warn(`JS 로드 타임아웃: ${url}`);
        resolve(url); // 타임아웃 시에도 계속 진행
      }, 10000);
      
      script.onload = () => {
        clearTimeout(timeout);
        loadedAssets.js.add(url);
        resolve(url);
      };
      
      script.onerror = () => {
        clearTimeout(timeout);
        console.error(`JS 로드 실패: ${url}`);
        resolve(url); // 에러 시에도 계속 진행
      };
      
      document.body.appendChild(script);
    } catch (error) {
      console.error(`JS 로드 예외 발생: ${url}`, error);
      resolve(url); // 예외 발생 시에도 계속 진행
    }
  });
};

// 레이아웃 애셋 로드 함수
const loadLayoutAssets = async (layoutName) => {
  const assets = LAYOUT_ASSETS[layoutName];
  if (!assets) return;
  
  // CSS 파일 로드 (먼저 로드하고 기다림)
  if (assets.css && assets.css.length > 0) {
    // CSS 파일들을 동시에 로드 (병렬 로드)
    const cssPromises = assets.css.map(url => loadCssFile(url));
    await Promise.all(cssPromises);
  }
  
  // JS 파일 로드 (CSS 로드 후 순차적으로 로드)
  if (assets.js && assets.js.length > 0) {
    // JS 파일들을 순차적으로 로드 (순서 보장)
    for (const url of assets.js) {
      await loadJsFile(url);
    }
  }
  
  // 특정 레이아웃의 특별한 처리
  if (layoutName === 'kor-environment') {
    // 환경협회 레이아웃의 경우 theme.js가 제대로 실행되기 위한 추가 대기 시간
    await new Promise(resolve => setTimeout(resolve, 300));
  }
  
  // Finapp 레이아웃의 특별한 처리
  if (layoutName === 'finapp') {
    // Splide 초기화를 위한 코드
    if (window.Splide) {
      document.addEventListener('DOMContentLoaded', () => {
        // 페이지 로드 후 Splide 초기화 코드 실행
        const carouselSingle = document.querySelector('.carousel-single');
        if (carouselSingle) {
          new window.Splide('.carousel-single', {
            perPage: 1,
            rewind: true,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: true
          }).mount();
        }
        
        const carouselMultiple = document.querySelector('.carousel-multiple');
        if (carouselMultiple) {
          new window.Splide('.carousel-multiple', {
            perPage: 2,
            rewind: true,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: true,
            breakpoints: {
              768: {
                perPage: 2
              },
              500: {
                perPage: 1
              }
            }
          }).mount();
        }
        
        const carouselSmall = document.querySelector('.carousel-small');
        if (carouselSmall) {
          new window.Splide('.carousel-small', {
            perPage: 9,
            rewind: false,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: false,
            breakpoints: {
              768: {
                perPage: 5
              },
              500: {
                perPage: 4
              }
            }
          }).mount();
        }
      });
    }
  }
  
  // Finapp 레이아웃의 특별한 처리
  if (layoutName === 'gpc') {
    // Splide 초기화를 위한 코드
    if (window.Splide) {
      document.addEventListener('DOMContentLoaded', () => {
        // 페이지 로드 후 Splide 초기화 코드 실행
        const carouselSingle = document.querySelector('.carousel-single');
        if (carouselSingle) {
          new window.Splide('.carousel-single', {
            perPage: 1,
            rewind: true,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: true
          }).mount();
        }
        
        const carouselMultiple = document.querySelector('.carousel-multiple');
        if (carouselMultiple) {
          new window.Splide('.carousel-multiple', {
            perPage: 2,
            rewind: true,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: true,
            breakpoints: {
              768: {
                perPage: 2
              },
              500: {
                perPage: 1
              }
            }
          }).mount();
        }
        
        const carouselSmall = document.querySelector('.carousel-small');
        if (carouselSmall) {
          new window.Splide('.carousel-small', {
            perPage: 9,
            rewind: false,
            type: 'loop',
            gap: 16,
            padding: 16,
            arrows: false,
            pagination: false,
            breakpoints: {
              768: {
                perPage: 5
              },
              500: {
                perPage: 4
              }
            }
          }).mount();
        }
      });
    }
  }
};

// 등록된 모든 레이아웃 맵
const LAYOUTS = {
  'kor-environment': KorEnvironmentLayout,
  'flone': FloneLayout,
  'finapp': FinappLayout, // Finapp 레이아웃 추가
  'gpc': GpcLayout, // Gpc 레이아웃 추가
  'midas': MidasLayout, // Midas 레이아웃 추가
  'finapp-component': FinappComponent, // 🚀 Finapp React 컴포넌트 추가
  'gpc-component': GpcComponent, // 🚀 Gpc React 컴포넌트 추가
  'midas-component': MidasComponent, // 🚀 Midas React 컴포넌트 추가
  // 여기에 더 많은 레이아웃 추가 가능
};

// 레이아웃 이름으로 컴포넌트 가져오기
export const getLayout = (layoutName) => {
  const Layout = LAYOUTS[layoutName] || LAYOUTS['flone']; // 기본값 설정
  
  return (props) => {
    const [assetsLoaded, setAssetsLoaded] = useState(false);
    
    // 레이아웃 변경 시 필요한 CSS/JS 파일 로드
    useEffect(() => {
      if (!layoutName) return;
      
      let isMounted = true;
      
      const loadAssets = async () => {
        try {
          // 애셋 로드 시작
          await loadLayoutAssets(layoutName);
          
          // 컴포넌트가 여전히 마운트된 상태인지 확인
          if (isMounted) {
            setAssetsLoaded(true);
          }
        } catch (error) {
          console.error(`${layoutName} 레이아웃 애셋 로드 실패:`, error);
          // 에러가 발생해도 렌더링은 진행
          if (isMounted) {
            setAssetsLoaded(true);
          }
        }
      };
      
      loadAssets();
      
      // 클린업 함수
      return () => {
        isMounted = false;
      };
    }, [layoutName]);
    
    // 애셋이 로드될 때까지 대기
    if (!assetsLoaded) {
      return <LoadingLayout>{props.children}</LoadingLayout>;
    }
    
    return (
      <Suspense fallback={<LoadingLayout>{props.children}</LoadingLayout>}>
        <Layout {...props} />
      </Suspense>
    );
  };
};

// 사용 가능한 모든 레이아웃 이름 가져오기
export const getAllLayoutNames = () => {
  return Object.keys(LAYOUTS);
};

export default {
  getLayout,
  getAllLayoutNames
}; 